import { Span } from "@vp/swan";
import React from "react";
import { useLocalization } from "../../hooks/useLocalizations";
import { IUnitPrice } from "../../types/pricing";
import ComparativePrice from "./ComparativePrice";
import VatMessage from "./VatMessage";

interface PricePerUnitProps {
  pricingInfo: IUnitPrice;
  /** @deprecated ignored; synchronous rendering */
  placeHolderText?: string;
  /** @deprecated use className instead */
  classNameWrapper?: string;
  className?: string;
  /** @deprecated not used */
  tenant?: string;
}

const PricePerUnit: React.FC<PricePerUnitProps> = ({
  pricingInfo,
  classNameWrapper,
  className,
}) => {
  const { t } = useLocalization();
  const wrapperClass = classNameWrapper || className;
  return (
    <Span className={["swan-pricing", wrapperClass].filter(Boolean).join(" ")}>
      <ComparativePrice
        listPrice={pricingInfo.unitListPrice}
        discountPrice={pricingInfo.unitDiscountPrice}
        currency={pricingInfo.currency}
        locale={pricingInfo.culture}
        minimumFractionDigits={pricingInfo.minimumFractionDigits}
      />
      <Span className="swan-pricing-offer">{t("price-platform.token-price.per-unit")}</Span>
      {!pricingInfo.hideVatMessage && (
        <>
          {" "}
          <VatMessage
            locale={pricingInfo.culture}
            vatInc={pricingInfo.vatInc}
            hideShippingMessageInVatMessage={pricingInfo.hideShippingMessageInVatMessage}
          />
        </>
      )}
    </Span>
  );
};

export default PricePerUnit;
